module.exports = __webpack_public_path__ + "img/destination_ruaha_ln.68d01f57.jpg";